<template>
  <div id="editUserInfo">
    <div class="head-title">
      <span class="head-text">店铺信息</span>
    </div>
    <div class="box">
      <div class="form-box">
        <el-form ref="form"  label-width="88px">
          <el-form-item label="店铺状态">
             <el-radio v-model="shop_status" label="0">维护中</el-radio>
             <el-radio v-model="shop_status" label="1">运营中</el-radio>
          </el-form-item> 
          <el-form-item label="商户账号">
            <el-input v-model="username" :disabled="true"></el-input> 
            <el-tooltip class="item" effect="dark" content="如果商户账号有变动，如手机号更换，请联系平台进行更改" placement="top"><span class="showDark el-icon-question"></span></el-tooltip>
          </el-form-item>
          <el-form-item label="店铺名">
            <el-input v-model="shop_name" ></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="company"></el-input>
          </el-form-item>
          <el-form-item label="主营商品">
            <el-input v-model="main_product"></el-input>
          </el-form-item>
          <el-form-item label="搜索框背景颜色">
             <el-color-picker v-model="back_color" show-alpha></el-color-picker>
          </el-form-item>
          <el-form-item label="店铺logo">
             <span>
                <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width:150px;height:150px;">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                 <el-tooltip class="item" effect="dark" content="删除logo" placement="top"><el-button @click="delImg(1)" type="danger" size="mini" icon="el-icon-delete"></el-button></el-tooltip>
                 <span style="font-size:12px;margin-left:10px;color:#cec8c8">建议宽高设置160 X 160</span>
            </span>
          </el-form-item>
          <el-form-item label="店铺banner">
             <span>
                <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess1"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                
                </el-upload>
                <el-tooltip class="item" effect="dark" content="删除banner" placement="top"><el-button  type="danger" @click="delImg(2)" size="mini" icon="el-icon-delete"></el-button></el-tooltip>
                <span style="font-size:12px;margin-left:10px;color:#cec8c8">建议宽高设置1920 X 150</span>
            </span>
          </el-form-item>
          <el-form-item label="客服电话">
            <el-input v-model="link_phone"></el-input>
          </el-form-item>
          <el-form-item label="公司地址">
            <el-input v-model="address"></el-input>
          </el-form-item>
          <el-form-item label="公司邮箱">
            <el-input v-model="email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-left:160px;" type="primary" @click="onSubmit">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      token: this.$cookies.get('shop_token'),
      uploadUrl: this.$store.state.serve + '/shop/uploadPost',
      form: {
        username: '',
        company: ''
      },
      shop_id: '',
      username: '',
      shop_name: '',
      company: '',
      main_product: '',
      back_color: 'rgba(238, 36, 69,1)',
      link_phone: '',
      address: '',
      email: '',
      imageUrl: '',
      imageUrl1: '',
      uploadFile1: [],
      uploadFile2: [],
      shop_status: 0,
      dialogImageUrl: '',
        dialogVisible: false,
        disabled: false
    }
  },
  created() {
    this.showUserInfo()
    this.$store.state.shop_top = 3;
    this.$store.state.shop_left = "店铺信息";
  },
  methods: {
    showUserInfo() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 5000)
      var where = {
        token: this.token
      }
      this.axios
        .get(this.serve + 'shop/show_user_info', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            let datas = data.data;
            this.shop_id = datas.id;
            this.username = datas.username;
            this.shop_name = datas.shop_name;
            this.company = datas.company;
            this.email = datas.email;
            this.address = datas.address;  
            this.link_phone = datas.link_phone;  
            this.back_color = datas.back_color;
            this.main_product = datas.main_product;
            this.shop_status = datas.shop_status;
            if(datas.logo){
              this.imageUrl = this.serve + datas.logo;  
            }
            if(datas.banner){
              this.imageUrl1 = this.serve + datas.banner;  
            }
            
            //this.form = data.data
           

          } else {
            this.$alerts.error('请求失败', this.$message)
          }
          loading.close()
        })
    },
    handleAvatarSuccess(res, file) {console.log(1)
            this.uploadFile1 = file.raw;
            this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess1(res, file) {
            this.uploadFile2 = file.raw;
            this.imageUrl1 = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        
        if (isPNG || isJPG) {
          if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            return false;
          }
        }else{
          this.$message.error('上传头像图片只能是 JPG 或 png 格式!');
          return false;
        }
        return true;
        //return isJPG && isLt2M;
    },
    handleRemove (file, fileList) {
        
         console.log(file)
    },
    delImg (type) { //删除图片操作
        this.axios
          .get(this.serve + 'shop/delImg', {
             params:{
                token:this.token,
                type: type
             }
          })
          .then(res => {
            var data = res.data
            if(data.status == 'success'){
                if(type == 1){
                  this.imageUrl = '';
                }else if(type == 2){
                  this.imageUrl1 = '';
                }
            }
        });
    },
    onSubmit() {
      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
            var form = new FormData();
            form.append('token',this.token);
            form.append('username',this.username);
            form.append('company',this.company);
            form.append('shop_name',this.shop_name);
            form.append('main_product',this.main_product);
            form.append('link_phone',this.link_phone);
            form.append('address',this.address);
            form.append('email',this.email);
            form.append('logo',this.uploadFile1);
            form.append('banner',this.uploadFile2);
            form.append('back_color',this.back_color);
            form.append('shop_status',this.shop_status);console.log()
            if(this.main_product == ''){
              this.$message.error('请填写主营商品信息！');
              return false;
            }else if(this.link_phone == ''){
              this.$message.error('请填写客服电话信息！');
              return false;
            }else if(this.uploadFile1.length <=0 && this.imageUrl == ''){
              this.$message.error('请设置你的店铺logo！');
              return false;
            }
          this.axios
          .post(this.serve + 'shop/editUserInfo', form, config)
          .then(res => {
            var data = res.data
              if(data.status == 'success'){
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }
             
          })
    }
  }
}
</script>
<style lang='scss'>
#editUserInfo {
  .head-title {
    width: 1060px;
    height: 46px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 46px;
    text-align: left;
  }
  .head-text {
    margin-left: 16px;
  }
  .box {
    width: 1060px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-box {
    width: 560px;
    margin: 40px;
  }
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 88px;
    line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 200px;
    display: block;
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 85%; 
}
.showDark{
    font-size:16px;
    color: #f39620;
    margin-left: 20px;
}
</style>